import { Component, input } from '@angular/core';

@Component({
  selector: 'common-page-container',
  standalone: true,
  templateUrl: './page-container.component.html',
  styleUrl: './page-container.component.scss',
})
export class PageContainerComponent {
  fullBleed = input(false);
}
